<template>
    <div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/">
                <icon name="dashboard" class="mr-2 w-4 h-4"
                      :class="isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dashboard</div>
            </Link>
        </div>

        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/payments">
                <icon name="money" class="mr-2 w-4 h-4"
                      :class="isUrl('payments') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('payments') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
                    Payments
                </div>
            </Link>
        </div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/orders">
                <icon name="cart" class="mr-2 w-4 h-4"
                      :class="isUrl('orders') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('orders') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
                    Orders
                </div>
            </Link>
        </div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/expenses">
                <icon name="money" class="mr-2 w-4 h-4"
                      :class="isUrl('expenses') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('expenses') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
                    Expenses
                </div>
            </Link>
        </div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/projects">
                <icon name="printer" class="mr-2 w-4 h-4"
                      :class="isUrl('projects') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('projects') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
                    Projects
                </div>
            </Link>
            <div class="mb-4">
                <Link class="group flex items-center py-3" href="/revenue-share">
                    <icon name="money" class="mr-2 w-4 h-4"
                          :class="isUrl('revenue-share') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                    <div :class="isUrl('revenue-share') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
                        Revenue-Split
                    </div>
                </Link>
            </div>
            <div class="mb-4">
                <Link class="group flex items-center py-3" href="/users">
                    <icon name="users" class="mr-2 w-4 h-4"
                          :class="isUrl('users') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                    <div :class="isUrl('users') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
                        Users
                    </div>
                </Link>
            </div>
<!--            <div class="mb-4">
                <Link class="group flex items-center py-3" href="/settings">
                    <icon name="office" class="mr-2 w-4 h-4"
                          :class="isUrl('settings') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                    <div :class="isUrl('settings') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
                        Settings
                    </div>
                </Link>
            </div>-->
            <div class="mb-4">
                <Link class="group flex items-center py-3" href="/settings/mpesa">
                    <icon name="office" class="mr-2 w-4 h-4"
                          :class="isUrl('settings.mpesa') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                    <div :class="isUrl('settings.mpesa') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
                        Mpesa Settings
                    </div>
                </Link>
            </div>
        </div>
    </div>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
    components: {
        Icon,
        Link,
    },
    methods: {
        isUrl(...urls) {
            let currentUrl = this.$page.url.substr(1)
            if (urls[0] === '') {
                return currentUrl === ''
            }
            return urls.filter((url) => currentUrl.startsWith(url)).length
        },
    },
}
</script>
